// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"147c12c7","28":"147c12c7","658":"4439042d","667":"147c12c7","721":"147c12c7","798":"147c12c7","930":"147c12c7"}[chunkId] + ".chunk.css";
};